import { render, staticRenderFns } from "./AddPhotoIcon.vue?vue&type=template&id=3d492305"
import script from "./AddPhotoIcon.vue?vue&type=script&lang=js"
export * from "./AddPhotoIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports